import type { EnvelopeEvent } from "./envelope.js";

const STORAGE_KEY = "physics.telemetry.offline";
const BACKOFF_STEPS_MS = [1000, 2000, 5000, 15000, 60000];

function hasLocalStorage(): boolean {
  return typeof localStorage !== "undefined";
}

/** 指数退避：1s → 2s → 5s → 15s → 60s（封顶），对应 tech/108 §8.3。 */
export function computeBackoffMs(attempt: number): number {
  const index = Math.min(Math.max(attempt, 0), BACKOFF_STEPS_MS.length - 1);
  return BACKOFF_STEPS_MS[index];
}

/** 断网缓冲。P0 用 localStorage；无 localStorage（如 SSR/单测非 jsdom 环境）时退化为内存队列。 */
export class OfflineQueue {
  private memoryFallback: EnvelopeEvent[] = [];

  enqueue(events: EnvelopeEvent[]): void {
    if (events.length === 0) return;
    this.writeAll([...this.readAll(), ...events]);
  }

  drain(): EnvelopeEvent[] {
    const events = this.readAll();
    this.writeAll([]);
    return events;
  }

  size(): number {
    return this.readAll().length;
  }

  private readAll(): EnvelopeEvent[] {
    if (!hasLocalStorage()) return this.memoryFallback;
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    try {
      return JSON.parse(raw) as EnvelopeEvent[];
    } catch {
      return [];
    }
  }

  private writeAll(events: EnvelopeEvent[]): void {
    if (!hasLocalStorage()) {
      this.memoryFallback = events;
      return;
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(events));
  }
}
